module.exports = __webpack_public_path__ + "img/finland-respiratory-diseases-male.f54ccac5.png";